const searchBar         = document.querySelector('.js-games-search-bar');
const TYPE_DELAY        = 500;
const HIDDEN_CLASS      = 'd-none';
const cards             = document.querySelectorAll('.js-games-card');
const noResultsMessage  = document.querySelector('.js-games-no-results');
let   typingTimeout;

const filterGames = () => {
    const query = searchBar.value.trim().toLowerCase();

    cards.forEach(card => {
        const text = card.textContent.toLowerCase();
        card.classList.toggle(HIDDEN_CLASS, !text.includes(query));
    });

    // Check if any card is visible
    const anyVisible = Array.from(cards).some(card =>
        !card.classList.contains(HIDDEN_CLASS)
    );

    // Show “No results” if none are visible
    noResultsMessage.classList.toggle(HIDDEN_CLASS, anyVisible);
};

const onKeyUp = () => {
    clearTimeout(typingTimeout);
    typingTimeout = setTimeout(filterGames, TYPE_DELAY);
};

if (searchBar) {
    searchBar.addEventListener('keyup', onKeyUp);
}
